export class ReenvioComprobanteViewModel {
    fecha:Date;
    todos:boolean;
    clientes:Array<string>;
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/models/viewmodels/ReenvioComprobanteViewModel.ts